import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../firebaseConfig'; // Firebase ayarlarını çek
import { sendPasswordResetEmail } from 'firebase/auth'; // Fonksiyonu çağır

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleReset = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        setError(null);

        try {
            // İŞTE SİHİRLİ KOMUT BURASI:
            await sendPasswordResetEmail(auth, email);
            
            setMessage("✓ Şifre sıfırlama bağlantısı gönderildi! (Lütfen Spam kutusunu da kontrol edin)");
        } catch (err) {
            console.error("Sıfırlama Hatası:", err.code);
            
            if (err.code === 'auth/user-not-found') {
                setError("Bu e-posta adresiyle kayıtlı bir hekim bulunamadı.");
            } else if (err.code === 'auth/invalid-email') {
                setError("Geçersiz e-posta formatı.");
            } else {
                setError("Bir hata oluştu: " + err.message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <h2 style={{ color: '#2c3e50', marginBottom: '10px' }}>Şifre Sıfırlama</h2>
                <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '20px' }}>
                    Sisteme kayıtlı e-posta adresinizi giriniz.
                </p>

                {message && <div style={successBox}>{message}</div>}
                {error && <div style={errorBox}>{error}</div>}

                <form onSubmit={handleReset}>
                    <div style={inputGroup}>
                        <input 
                            type="email" 
                            style={inputStyle} 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="doktor@klinik.com"
                            required
                        />
                    </div>
                    <button type="submit" disabled={loading} style={resetBtn}>
                        {loading ? "GÖNDERİLİYOR..." : "SIFIRLAMA BAĞLANTISI GÖNDER"}
                    </button>
                </form>

                <div style={{ marginTop: '25px' }}>
                    <Link to="/login" style={linkStyle}>← Giriş Ekranına Dön</Link>
                </div>
            </div>
        </div>
    );
}

// --- TASARIM NESNELERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh', 
    background: '#eef2f3',
    boxSizing: 'border-box',
    width: '100%',
    padding: '20px',
    paddingTop: 'max(20px, env(safe-area-inset-top))', // iOS Çentik Koruması
    paddingBottom: 'env(safe-area-inset-bottom)'       // iOS Alt Bar Koruması
};

const cardStyle = { 
    background: '#fff', 
    padding: '30px 20px', 
    borderRadius: '24px', 
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)', 
    width: '100%', 
    maxWidth: '400px', 
    textAlign: 'center',
    boxSizing: 'border-box'
};

const inputGroup = { textAlign: 'left', marginBottom: '20px', boxSizing: 'border-box' };

const inputStyle = { 
    width: '100%', 
    padding: '14px', 
    border: '1px solid #dfe4ea', 
    borderRadius: '12px', 
    fontSize: '16px', // iOS Safari zoom engellemek için kritik
    boxSizing: 'border-box',
    outline: 'none',
    WebkitAppearance: 'none'
};

const resetBtn = { 
    width: '100%', 
    padding: '15px', 
    background: '#3498db', 
    color: '#fff', 
    border: 'none', 
    borderRadius: '12px', 
    fontSize: '14px', 
    fontWeight: 'bold', 
    cursor: 'pointer',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent'
};

const linkStyle = { color: '#3498db', textDecoration: 'none', fontWeight: 'bold', fontSize: '14px' };
const successBox = { padding: '10px', background: '#d4edda', color: '#155724', borderRadius: '8px', marginBottom: '15px', fontSize: '13px', boxSizing: 'border-box' };
const errorBox = { padding: '10px', background: '#f8d7da', color: '#721c24', borderRadius: '8px', marginBottom: '15px', fontSize: '13px', boxSizing: 'border-box' };